import { useRef } from "react";
import { isAxiosError } from "axios";

// Reuse the same command id after an uncertain reply, unless the payload changes.
export function useCommand() {
  const saved = useRef({ key: "", id: "" });
  return Object.assign(
    (payload: unknown) => {
      const key = JSON.stringify(payload);
      if (saved.current.key !== key)
        saved.current = { key, id: crypto.randomUUID() };
      return saved.current.id;
    },
    {
      reset: () => {
        saved.current = { key: "", id: "" };
      },
    },
  );
}
export const errorText = (e: unknown) =>
  isAxiosError(e) && typeof e.response?.data?.message === "string"
    ? e.response.data.message
    : "Opération non confirmée. Actualisez puis réessayez ; votre saisie est conservée.";
